export default {
  // Start:: Set Authenticated User Data
  setAuthenticatedUserData(state, payload) {
    if (payload.id) {
      state.userId = payload.id;
      localStorage.setItem("glow_up_dashboard_user_id", payload.id);
    }
    if (payload.token) {
      state.userToken = payload.token;
      localStorage.setItem("glow_up_dashboard_user_token", payload.token);
    }

    if (payload.type) {
      state.userType = payload.type;
      localStorage.setItem("glow_up_dashboard_user_type", payload.type);
    }
    if (payload.name) {
      state.userName = payload.name;
      localStorage.setItem("glow_up_dashboard_userName", payload.name);
    }
    if (payload.email) {
      state.email = payload.email;
      localStorage.setItem("glow_up_dashboard_email", payload.email);
    }
    console.log("payload.image", payload);
    if (payload.image) {
      state.userAvatar = payload.image;
      localStorage.setItem("glow_up_dashboard_user_avatar", payload.image);
    }
    if (payload.ability) {
      state.ability = payload.ability;
      localStorage.setItem("glow_up_dashboard_user_ability", payload.ability);
    }
  },
  // End:: Set Authenticated User Data
};
